import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { config, getClientId, getCookieDomain, getEnv } from './config';
import Cookies from 'js-cookie';
export function sendNewRelicEvent(eventData) {
  var env = getEnv();
  var newRelic = config[env].newRelic;
  var url = "https://insights-collector.newrelic.com/v1/accounts/".concat(newRelic.id, "/events");
  var location = typeof window != 'undefined' ? window.location : null;
  var data = _objectSpread({
    env: env,
    eventType: 'OneAuthSdkEvent',
    clientId: getClientId(),
    domain: getCookieDomain(),
    website: location === null || location === void 0 ? void 0 : location.host,
    path: location === null || location === void 0 ? void 0 : location.pathname,
    callTimestamp: Date.now(),
    sessionId: Cookies.get('CSessionID'),
    userAgent: typeof window !== 'undefined' ? window.navigator.userAgent : 'unknown',
    url: typeof window !== 'undefined' ? window.location.href : 'unknown'
  }, eventData);
  var nrEventBody = JSON.stringify(data);
  return fetch(url, {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'X-insert-Key': newRelic.key
    },
    body: nrEventBody
  });
}